import ApplicationPage from './ApplicationPage';
export { ApplicationPage };
export default ApplicationPage;
